import { FC, PropsWithChildren } from 'react';

export const RuleValue: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='flex w-fit items-center justify-center rounded-md border border-quaternary-300 bg-white-100 px-2 py-1 text-xs font-medium text-secondary-700'>
      {children}
    </div>
  );
};
